<template>
  <main id="LmMenuBuilderNewOrEdit" class="wrapper-content w-100">
    <LmLoading v-if="isLoading" />
    <template>
      <h1>Generador de Menues</h1>
      <LmForm ref="lmFormRef" >
        <portal-target name="destination-after-title" slim/>
        <LmTextInput
          class="col-12 px-0"
          :v="$v.form.menuName"
          v-model="form.menuName"
          label="Nombre"
          placeholder="Nombre del menú"
        />
        <LmTextInput
          class="col-12 px-0"
          v-model="form.menuDescription"
          label="Descripción"
          placeholder="Descripción del menú"
        />
      </LmForm>
      <hr>

      <div class="row">
        <div class="col">
          <h4>Opciones de Menú</h4>
          <LmTreeSelect
            :label="'Seleccione los listados a mostrar'"
            class="col-12 px-0"
            :options="listBuilderOptions"
            :multiple="true"
            v-model="form.menuContent"
          />
          <a @click="$bvModal.show('external-option-modal')" class="link-primary">Agregar opción externa</a>
          <hr>
          <h4>Quienes pueden ver el menú</h4>
          <label>Seleccione las áreas, roles o perfiles que podrán verlo</label>
          <div class="row">
            <div class="col">
              <LmTreeSelect
                :label="'Areas'"
                class="col-12 px-0"
                pathToGetOptions="/customer/areas"
                :multiple="true"
                v-model="form.areas"
              />
            </div>

            <div class="col">
              <LmTreeSelect
                :label="'Sub Areas'"
                class="col-12 px-0"
                pathToGetOptions="/customer/subareas"
                :multiple="true"
                v-model="form.subAreas"
              />
            </div>
          </div>

          <LmTreeSelect
            :label="'Roles'"
            class="col-12 px-0"
            pathToGetOptions="/customer/roles"
            :multiple="true"
            v-model="form.roles"
          />

          <LmTreeSelect
            :label="'Perfiles'"
            class="col-12 px-0"
            pathToGetOptions="/customer/profilegroups"
            :multiple="true"
            v-model="form.profilegroups"
          />

          <hr>
          <h4>Seleccione la prioridad del Menú</h4>
          <label>Escoja un valor de 1 a 10</label>
          <input type="range" class="custom-range" min="1" max="10" v-model="form.priority">
          <strong v-if="form.priority <= 3 && form.priority >= 1" class="text-success">Prioridad Alta</strong>
          <strong v-if="form.priority <= 6 && form.priority >= 4" class="text-warning">Prioridad Media</strong>
          <strong v-if="form.priority <= 10 && form.priority >= 7" class="text-danger">Prioridad Baja</strong>
          <p>{{form.priority}}</p>
        </div>
        <div class="col">
          <div class="col-12" v-if="form.menuContent.length">
          <h5>Elija el orden</h5>
            <draggable
              class="list-group my-3"
              tag="ul"
              v-model="form.menuContent"
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
              handle=".handle"
            >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <li
                  class="list-group-item"
                  v-for="(menu, index) in form.menuContent"
                  :key="menu.id"
                >
                  <div class="d-flex align-items-center justify-content-between w-100" v-b-toggle="`collapse-${index}`">
                    <div class="d-flex align-items-center justify-content-between">
                      <font-awesome-icon icon="bars" class="handle m-2"></font-awesome-icon>
                      <font-awesome-icon icon="chevron-down" class="mx-2"></font-awesome-icon>
                      <span class="badge bg-primary text-white mx-2"><strong>{{index + 1}}</strong></span>
                      <i class="dripicons mx-2" v-if="form.menuContent[index].icon" :class="form.menuContent[index].icon.name" />
                    </div>
                    {{form.menuContent[index].name}}
                    <font-awesome-icon icon="times" class="remove" @click="form.menuContent.splice(index, 1)"></font-awesome-icon>
                  </div>

                    <b-collapse
                    accordion="my-accordion"
                    :id="`collapse-${index}`"
                    class="p-3 rounded-lg"
                    >
                      <b-row>
                        <b-col>
                          <label>Alias</label>
                          <input type="text" class="col-12 form-control form-control-sm mb-3" v-model="form.menuContent[index].alias" placeholder="Alias de la opción"/>
                          <label>Icono</label>
                          <treeselect
                              v-model="form.menuContent[index].icon"
                              :multiple="false"
                              :options="iconsOptions"
                              valueFormat="object"
                              :normalizer="normalizer"
                              class="col-12 p-0"
                            >
                              <label slot="option-label" slot-scope="{ node, labelClassName }" class="col-12" :class="labelClassName">
                                <i class="dripicons" :class="node.label"/>
                                {{ node.label }}
                              </label>
                          </treeselect>
                        </b-col>
                        <b-col>
                          <LmRadio
                            class="pt-1"
                            v-model="form.menuContent[index].newTab"
                            name="newtab"
                            label="Abrir en nueva pestaña"
                            :options="[
                              {text: 'Si', value: true},
                              {text: 'No', value: false}
                            ]"
                          />
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </li>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <hr>

      <!-- Action Buttons -->
      <div class="row">
        <LmButton
          :value="$t('go_back')"
          class="col-auto"
          type="button"
          :isProcessing="isProcessing"
          buttonClass="btn-secondary"
          @click="onGoBack()"
        />
        <LmButton
          v-if="!deleted"
          :value="$t('save')"
          class="col-auto"
          type="button"
          buttonClass="btn-primary"
          :isProcessing="isProcessing"
          @click="onSubmit()"
        />
        <LmButton
          v-if="isOnEditMode && !deleted && !published"
          :value="$t('publish')"
          class="col-auto"
          type="button"
          buttonClass="btn-success"
          :isProcessing="isProcessing"
          @click="onPublish()"
        />
        <LmButton
          v-if="isOnEditMode && !deleted && published"
          :value="$t('Despublicar')"
          class="col-auto"
          type="button"
          buttonClass="btn-warning"
          :isProcessing="isProcessing"
          @click="onPublish()"
        />
        <LmButton
          v-if="isOnEditMode && !deleted && !published"
          :value="$t('delete')"
          class="col-auto"
          type="button"
          action="delete"
          buttonClass="btn-danger"
          :isProcessing="isProcessing"
          @click="onDelete()"
        />
      </div>
      <!-- External Link Modal -->
      <b-modal
        id="external-option-modal"
        title="Agregar opción de menú externa"
        size="l"
        :ok-title="$t('add')"
        @ok="addExternalOption"
        @hide="clearExternalLinkFields"
        :cancel-title="$t('cancel')"
      >
        <div class="col">
          <LmTextInput
            v-model="externalLink.name"
            label="Nombre"
            placeholder="Nombre de la opción"
          />
          <LmTextInput
            v-model="externalLink.href"
            label="Link"
            placeholder="http:// o https://"
          />
          <LmRadio
            class="pt-1"
            v-model="externalLink.newTab"
            name="newtab"
            label="Abrir en nueva pestaña"
            :options="[
              {text: 'Si', value: true},
              {text: 'No', value: false}
            ]"
          />
        </div>
      </b-modal>
    </template>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmForm from '@/components/form/LmForm'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import Treeselect from '@lumile/vue-treeselect'
import LmRadio from '@/components/form/elements/LmRadio'
import '@lumile/vue-treeselect/dist/vue-treeselect.css'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { required } from 'vuelidate/lib/validators'
import draggable from 'vuedraggable'

export default {
  mixins: [lmToasts],
  components: {
    draggable,
    LmForm,
    LmFormBuilder,
    LmButton,
    LmTextInput,
    LmTreeSelect,
    Treeselect,
    LmRadio
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name
        }
      },
      drag: false,
      listBuilderOptions: [],
      iconsOptions: [],
      deleted: false,
      published: false,
      form: {
        menuName: '',
        menuDescription: '',
        menuContent: [],
        roles: [],
        profilegroups: [],
        subAreas: [],
        areas: [],
        priority: 1
      },
      externalLink: {
        name: '',
        href: '',
        newTab: false
      },
      isProcessing: false
    }
  },
  validations: {
    form: {
      menuName: {
        required
      },
      menuContent: {
        required
      },
      priority: {
        required
      }
    }
  },
  computed: {
    pathToGetOptionsForIcons () {
      return `/codificatorbuilder/codificators/61855e1153e71042804ab9f8`
    },
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    async onSubmit () {
      try {
        this.isProcessing = true

        // Validaciones
        await this.validateForm(this.$v)

        if (!this.isOnEditMode) {
          // Nuevo
          const res = await commonsApi.axiosPostWrapper('/menubuilder/', this.form)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' el menú'} correctamente.`, 'Se guardó exitosamente')
        } else {
          // Editar
          const res = await commonsApi.axiosPutWrapper(`/menubuilder/${this.$route?.params?.id}`, this.form)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' el menú'} correctamente.`, 'Se guardó exitosamente')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onGoBack () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    async onPublish () {
      try {
        this.isProcessing = true

        // Guardo los cambios y evito que salga un doble toaster
        await commonsApi.axiosPutWrapper(`/menubuilder/${this.$route?.params?.id}`, this.form)

        // Validaciones
        await this.validateForm(this.$v)

        if (!this.published) {
          // Publicar
          const res = await commonsApi.axiosPutWrapper(`/menubuilder/publish/${this.$route?.params?.id}`, this.form)
          this.lmToastSuccessMessage(`Se publicó ${res?.data?.name || ' el menú'} correctamente.`, 'Se publicó exitosamente')
        } else {
          // Despublicar
          const res = await commonsApi.axiosPutWrapper(`/menubuilder/publish/${this.$route?.params?.id}`, this.form)
          this.lmToastSuccessMessage(`Se despublicó ${res?.data?.name || ' el menú'} correctamente.`, 'Se despublicó exitosamente')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
        this.onGoBack()
      }
    },
    async onDelete () {
      try {
        this.isProcessing = true
        this.published = false

        const res = await commonsApi.axiosPutWrapper(`/menubuilder/delete/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se eliminó ${res?.data?.name || ' el menú'} correctamente.`, 'Se eliminó correctamente')
        this.onGoBack()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    validateForm (validation) {
      validation.$touch()
      // Verifico que al menos un area o rol esté asignada al menú
      if (this.form.areas.length === 0 && this.form.subAreas.length === 0 && this.form.roles.length === 0 && this.form.profilegroups.length === 0) {
        this.lmToastDangerMessage(this.$t('Debe completar quienes pueden ver el menú para continuar'), 'Error')
        throw new Error('validation error')
      }
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    addExternalOption (e) {
      // Evito que se cierre el modal y valido
      e.preventDefault()
      this.validateExternalOptionsFields()

      // Asigno propiedades para el treeselect
      this.externalLink.id = this.externalLink.name.split(' ').join('-').toLowerCase()
      this.externalLink.alias = this.externalLink.name

      // Cargo la opción en el treeselect y la dejo seleccionada
      this.listBuilderOptions.push(this.externalLink)
      this.form.menuContent.push(this.externalLink)

      // Cierro modal manualmente y luego se limpian campos con el @hide
      this.$nextTick(() => {
        this.$bvModal.hide('external-option-modal')
      })
    },
    validateExternalOptionsFields () {
      // Valido Nombre
      if (this.externalLink.name === '') {
        this.lmToastDangerMessage('Debe asignar un nombre a la opción', 'Error')
        throw new Error('validation error')
      }
      // Valido URL
      try {
        // eslint-disable-next-line
        const url = new URL(this.externalLink.href)
      } catch (_) {
        this.lmToastDangerMessage('Debe asignar un link válido', 'Error')
        throw new Error('validation error')
      }
    },
    clearExternalLinkFields () {
      this.externalLink = {}
      this.externalLink.newTab = false
    }
  },
  async created () {
    try {
      if (this.$route?.params?.id) {
        this.isLoading = true
        const menuBuilder = await commonsApi.axiosGetWrapper(`/menubuilder/${this.$route?.params?.id}`)
        this.form.menuName = menuBuilder.data?.menuName
        this.form.menuDescription = menuBuilder.data?.menuDescription
        this.form.menuContent = menuBuilder.data?.menuContent
        this.form.areas = menuBuilder.data?.areas
        this.form.subAreas = menuBuilder.data?.subAreas
        this.form.roles = menuBuilder.data?.roles
        this.form.profilegroups = menuBuilder.data?.profilegroups
        this.published = menuBuilder.data?.published
        this.deleted = menuBuilder.data?.deleted
        this.form.priority = menuBuilder.data?.priority
      }
    } catch (error) {
      console.log(error)
    }

    // Obtengo el listado de ListBuilders para mostrar en las opciones de menú posibles
    try {
      const listsPromise = commonsApi.axiosGetWrapper('/listbuilder/all')
      const datatablesPromise = commonsApi.axiosGetWrapper('/datatables/all')
      const [ lists, datatables ] = await Promise.all([listsPromise, datatablesPromise])
      const options = [...lists.data.items, ...datatables.data.items]
      this.listBuilderOptions = options.map(el => {
        const menu = this.form.menuContent.find(m => m.id === el.id)
        const path = el?.slug ? `/listado/${el.slug}` : `/listbuilder/view/${el.id}`
        return {
          name: el.name,
          alias: menu?.alias,
          id: el.id,
          path: path,
          icon: menu?.icon || null
        }
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }

    // Obtengo listado de iconos
    try {
      // TODO: FIX HARDCODED
      const icons = await commonsApi.axiosGetWrapper('/codificatorbuilder/codificators/618585e191be4f094ce0b2e7')
      this.iconsOptions = icons.data.items
    } catch (error) {
      console.log(error)
    }
  }
}

</script>

<style>
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0%;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.handle {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.remove {
  cursor: pointer;
}
</style>
